import { useSelector } from 'react-redux';
import { useOnComponentMount } from './use-on-component-mount';
import { useCurrentUserId } from './use-current-user-id';
import Global from '../store/global-selectors';
import { Yofi } from '../services/analytics-services/yofi';

/**
 * Initializes a Yofi session. ({@link https://docs.yofi.ai/yofi-telemetry/telemetry-web-sdk/quick-start})
 * Hook should only be called one time.
 * @returns {void}
 */
export const useYofiSession = () => {
  const userId = useCurrentUserId();
  const sellerId = useSelector(Global.selectSellerSellerId);
  const sellerCreateDate = useSelector(Global.selectSellerCreateDateUTC);
  const { createDate: userCreateDate } = useSelector(Global.selectUserCurrentUserInfo) || {};

  useOnComponentMount(() => {
    Yofi.startSession({
      userId,
      userCreateDate,
      sellerId,
      sellerCreateDate,
    });
  });
};
